module.exports = __webpack_public_path__ + "ff6a21e1ffa30e9741aa68ec376c7e79.MP3";